import { Outlet } from 'react-router-dom';

export const QrRequestAccessOutlet = () => <Outlet />;
